// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"501":"f7ca57f6","787":"5901b17b"}[chunkId] + ".chunk.js";
};